// Get weapon-specific targeting messages for deploy effects

const weaponTargetingMessages = {
  119: "Select what unit you want to confuse.", // Toxic Shroud Grenade
  333: "Select what enemy unit you want to immobilize.", // Tranquilizer Blaster
  // Add more weapon-specific messages as needed
  // Format: weaponId: "Custom message"
};

/**
 * Get the targeting message for a specific weapon
 * @param {number|null|undefined} weaponId - The weapon ID
 * @returns {string} - The weapon-specific message or a generic fallback
 */
function getWeaponTargetingMessage(weaponId) {
  if (weaponId && weaponTargetingMessages[weaponId]) {
    return weaponTargetingMessages[weaponId];
  }
  
  // Generic fallback message
  return "Select a target for weapon effect";
}

export default getWeaponTargetingMessage;

